export const MINIMUM_IF = 25
export const MINIMUM_IDIA = 15
export const MINIMUM_RON = 5
